/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/appCardList.config.json";
// import axios from "axios";
// import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
// import { USER_GROUP_LIST } from "../graphql";
import { VApplication } from "../../../application";
import { BreadcrumbService } from "../../breadcrumbService";

// const getGraphQLModule = () => {
//   const app = VApplication.getInstance();
//   return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
// };
const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.BreadcrumbService") as BreadcrumbService;
};

export interface IGetHolderGroupProps {
  offset?: number;
  size?: number;
  criteria?: any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: any): Promise<any>;
}

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getAppCardListProps.bind(this),
    };
  }

  async getAppCardListProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    // const graphqlModule = getGraphQLModule();
    // const client = graphqlModule.getClient("graphql-gateway");
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: USER_GROUP_LIST,
    //       variables: {
    //         input: {
    //           offset: args?.offset ?? 0,
    //           size: args?.size ?? 10,
    //           criteria: {
    //             parent: null,
    //             ...args?.criteria
    //           },
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data?.getListOfUserGroup) {
    //       let _templateData = this.formatHolderGroup(
    //         res?.data?.getListOfUserGroup?.data
    //       );
    //       return {
    //         appCardList: _templateData,
    //         isEmpty: res?.data?.getListOfUserGroup?.data?.length <= 0,
    //         activePage: res?.data?.getListOfUserGroup?.currentPage,
    //         pageSize: res?.data?.getListOfUserGroup?.pageSize,
    //         totalCount: res?.data?.getListOfUserGroup?.totalCount,
    //         totalPages: res?.data?.getListOfUserGroup?.totalPages,
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   throw err;
    // }
    // return{
    //   config:{ ...config, ...(breadcrumbItems || {}) }
    // }
    return { ...(config || {}) };
  }

  private formatHolderGroup(data: any) {
    console.log("formatHolderGroup =>", data);
    let _appCard = data.map((item: any) => {
      return {
        appCardId: item?._id,
        appCardImage: item?.logo,
        appCardTitle: item?.name,
        appCardDescription: item?.description,
      };
    });

    return _appCard;
  }
}
